import { __ } from '@wordpress/i18n';
import {PanelBody} from '@wordpress/components';
import {VayuBlocksToggleControl, VayuBlocksBackground, IconSelector } from '@vayu-blocks';

const Layout = ({ attributes, setAttributes, openPanels, onTogglePanel}) => {

    return (

        <PanelBody 
            title={__('Timeline Icon', 'vayu-blocks')} 
            opened={openPanels['slide-effect']}
            onToggle={() => onTogglePanel('slide-effect')} 
        >

            <VayuBlocksToggleControl
                label={ __( 'Global', 'vayu_blocks' ) }
                checked={ attributes.iconglobal }
                onChange={ ( value ) => setAttributes( { iconglobal: value } )} 
                help = "Turning this on will disable the global style."
            />

            {attributes.iconglobal && (
                <>

                    <IconSelector
                        value={{iconName: attributes.iconName}}
                        onChange={(val) =>setAttributes({iconName: val.iconName})}
                    />

                    <br/>

                    <VayuBlocksBackground
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        colorPanel = {[
                                    {
                                        active: ['gradient'],
                                        label: 'Background',
                                        value: attributes.gbiconcolor,
                                        key: 'gbiconcolor',
                                    },
                                    {
                                        active: ['gradient'],
                                        label: 'Color',
                                        value: attributes.gbiconiconcolor,
                                        key: 'gbiconiconcolor',
                                    }]
                                }
                    />  
                </>
            )}

        </PanelBody> 
    );
};

export default Layout;